<div class="topbar-area home9-topbar">
  <div class="container">
    <div class="row y-middle">
      <div class="col-md-8">
        <ul class="topbar-contact">
          <li>
            <i class="flaticon-phone"></i>+91 9014219376
          </li>
          <li>
            <i class="flaticon-email"></i>
            <a href="mailto:vivekanandacollegekadiri@gmail.com"> &nbsp;vivekanandacollegekadiri@gmail.com</a>
          </li>
          
        </ul>
      </div>
      <div class="col-md-4 text-right">
        <ul class="topbar-right">
          <li class="btn-part">
            <a class="apply-btn" href="https://www.sbescampus.in/" target="_blank">Sbes E-Campus</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
